import { ReactNode } from 'react';

type SwatchesPickerProps = {
  color: string | undefined;
  onChange: (color: string) => void;
  presetColors: string[];
};

export default function SwatchesPicker(props: SwatchesPickerProps): ReactNode {
  const { color, onChange, presetColors } = props;

  return (
    <div className="picker">
      <div className="picker-swatches">
        {presetColors.map((presetColor) => (
          <button
            type="button"
            key={presetColor}
            className={`picker-swatch ${presetColor === color ? 'picker-swatch-active' : ''}`}
            style={{ background: presetColor }}
            onClick={() => onChange(presetColor)}
          />
        ))}
      </div>
    </div>
  );
}
